import { Toro } from '../common/enumerations';
import RunningStatus = Toro.RunningStatus;

export class ActiveProgramInfo
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
            this.RunningProgramStatus = json['RunningProgramStatus'] || RunningStatus.Unknown;
        }
    }
    RunningProgramStatus: RunningStatus;
    RunningProgramNumber: number;
    RunningProgramName: string;
    RunningProgramRemainingSeconds: number;
    TotalRuntime: number;
    IsForced = false;
}
